import moment from 'moment';
import { IRefundLogFilters } from 'src/view/screens/RefundLogScreen/screens/RefundLog/types/refundLog';
import { SORTING_DIRECTION } from '~/constants/main';

export enum REFUND_LOG_COLUMN {
  DATE = 'refund_journal_date_time_col_hdr',
  AUTHOR = 'refund_journal_refund_issuer_col_hdr',
  BRANCH = 'refund_journal_branch_col_hdr',
  ORDER_ID = 'refund_journal_order_id_col_hdr',
  AMOUNT = 'refund_journal_amount_and_valuta_col_hdr',
  STATUS = 'refund_journal_refund_status_col_hdr',
  TYPE = 'refund_journal_refund_type_col_hdr',
  REASON = 'refund_journal_refund_reason_col_hdr',
  ARN = 'refund_journal_refund_transaction_arn_col_hdr',
}

export enum REFUND_LOG_SORTING_COLUMN {
  ID = 'id',
  AUTHOR_ID = 'author_id',
  BRANCH_ID = 'branch_id',
  TRANSACTION_AT = 'transaction_at',
  AUTHOR_NAME = 'author_name',
  AUTHOR_PHONE = 'author_phone',
  BRANCH_NAME = 'branch_name',
  ORDER_REFERENCE = 'order_reference',
  TRANSACTION_AMOUNT = 'transaction_amount',
  TRANSACTION_CURRENCY = 'transaction_currency',
  TRANSACTION_STATUS = 'transaction_status',
  TRANSACTION_TYPE = 'transaction_type',
  TRANSACTION_REASON = 'transaction_reason',
  TRANSACTION_ARN = 'transaction_arn',
}

export enum TRANSACTION_ACTIONS {
  ACTION_CHARGE = 1,
  ACTION_REFUND = 2,
  ACTION_PARTIAL_REFUND = 3,
  ACTION_RECHARGE = 4,
}

export enum REFUND_ACTIONS {
  ACTION_REFUND = TRANSACTION_ACTIONS.ACTION_REFUND,
  ACTION_PARTIAL_REFUND = TRANSACTION_ACTIONS.ACTION_PARTIAL_REFUND,
}

export const REFUND_ACTIONS_TXT = {
  [REFUND_ACTIONS.ACTION_REFUND]: 'refund_journal_refund_type_full',
  [REFUND_ACTIONS.ACTION_PARTIAL_REFUND]: 'refund_journal_refund_type_partial',
};

export const defaultRefundLogFilters: IRefundLogFilters = {
  sortBy: REFUND_LOG_SORTING_COLUMN.TRANSACTION_AT,
  sortDir: SORTING_DIRECTION.DESCENDING,
  actions: [REFUND_ACTIONS.ACTION_REFUND, REFUND_ACTIONS.ACTION_PARTIAL_REFUND],
  startDate: moment().startOf('month').unix(),
  endDate: moment().unix(),
};
